var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:_vm.isAvailable ? 'online' : 'offline'},[_vm._v(" "+_vm._s(_vm.isAvailable ? _vm.$t('Online') : _vm.$t('Offline'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }